import styled from '@emotion/styled';
import { SimpleGrid, Title } from '@mantine/core';

type StickyHeader = {
  isSidePanel?: boolean;
};

const PageHeader = styled(SimpleGrid)<StickyHeader>(
  ({ theme, isSidePanel }) => `
    background-color: ${theme.white};
    z-index: 4;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    position: relative;

    ${
      isSidePanel
        ? `
      padding-left: ${theme.spacing.sm}px;
      padding-right: ${theme.spacing.sm}px;
      padding-bottom: ${theme.spacing.md}px;
      padding-top: ${theme.spacing.xl}px;
      gap: 0,
      top: 0;
    `
        : `
      padding-top: ${theme.spacing.xl}px;
      padding-bottom: ${theme.spacing.xl}px;
      gap: ${theme.spacing.sm}px;
      top: 0;

      ${theme.fn.largerThan('xs')} {
        transition-duration: .35s;
        transition-timing-function: linear;
        transition-property: padding, gap;
      }
      ${theme.fn.smallerThan('lg')} {
        padding-left: ${theme.spacing.sm}px;
        padding-right: ${theme.spacing.sm}px;
        padding-top: ${theme.spacing.lg}px;
        padding-bottom: ${theme.spacing.md}px;
        gap: ${theme.spacing.md}px;
      }
      ${theme.fn.smallerThan('sm')} {
        padding-top: ${theme.spacing.xl}px;
      }
      ${theme.fn.smallerThan('xs')} {
        gap: 0px;
      }
    `
    }
  `
);

const PageHeaderContainer = styled.div<{ isSidePanel?: boolean }>(
  ({ theme, isSidePanel }) => `
    width: ${theme.other.screenWidth.lg};
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.spacing.md * 2}px;

    ${
      isSidePanel
        ? `
      width: 100%;
      align-items: flex-start;
      flex-direction: column;
      position: relative;
      gap: ${theme.spacing.xl}px;
    `
        : `
      ${theme.fn.smallerThan('lg')} {
        width: 100%;
      }
      ${theme.fn.smallerThan('sm')} {
        align-items: flex-start;
        flex-direction: column;
        position: relative;
        gap: ${theme.spacing.xl}px;
      }
    `
    }
  `
);

const PageHeaderTitle = styled(Title)<StickyHeader>(
  ({ theme, isSidePanel }) => `
    margin-top: ${isSidePanel ? 0 : theme.spacing.lg}px;

    ${
      isSidePanel
        ? `
      width: 100%;
      font-size: ${theme.fontSizes.xl}px;
    `
        : `
      font-size: ${theme.fontSizes.md * 2}px;
      width: ${theme.other.screenWidth.lg};

      ${theme.fn.smallerThan('lg')} {
        width: 100%;
      }
      ${theme.fn.smallerThan('xs')} {
        font-size: ${theme.fontSizes.xl}px;
        transform: translateX(0);
      }
    `
    }
  `
);

const PageHeaderContent = styled.div<{ isSidePanel?: boolean }>(
  ({ theme, isSidePanel }) => `
    display: flex;
    flex-wrap: wrap;

    ${
      isSidePanel
        ? `
      row-gap: ${theme.fontSizes.lg / 2}px;
      column-gap: ${theme.fontSizes.xl}px;
    `
        : `
      gap: ${theme.fontSizes.md}px;

      ${theme.fn.smallerThan('sm')} {
        row-gap: ${theme.fontSizes.lg / 2}px;
        column-gap: ${theme.fontSizes.xl}px;
      }
    `
    }
  `
);

const PageHeaderActions = styled.div<StickyHeader>(
  ({ theme, isSidePanel }) => `
    display: flex;
    gap: ${theme.spacing.sm}px;
    align-items: center;

    ${
      isSidePanel
        ? `
      justify-content: stretch;
      width: '100%';
      display: flex;
    `
        : `
      ${theme.fn.smallerThan('xs')} {
        position: relative;
        right: 0;
      }
    `
    }
  `
);

export { PageHeader, PageHeaderContainer, PageHeaderTitle, PageHeaderContent, PageHeaderActions };
